module.exports = __webpack_public_path__ + "static/media/pp-avatar-empty.2886f871.svg";